/**
 * Created by decipaliz on 29.03.2024
 */

Actor.prototype.ctor = cleverapps.extendFunc(Actor.prototype.ctor, function (...args) {
    this._super(...args);
    cleverapps.exclamation.on("show", cleverapps.throttle(1000, this.exclamationAnimation.bind(this)), this);
});

Actor.prototype.showUpAnimation = function (silent) {
    if (silent) {
        this.setVisible(true);
        return;
    }

    const scene = cleverapps.Scenes.GetRunningScene();
    const styles = cleverapps.styles.Actor;
    const targetPosition = this.getPosition();

    switch (cleverapps.resolution.mode) {
        case cleverapps.WideMode.HORIZONTAL: case cleverapps.WideMode.SQUARE:
            this.setAlignment(scene.width + this.width * 2, this.y);
            break;
        case cleverapps.WideMode.VERTICAL:
            this.setAlignment(this.x, -scene.height - this.height * 2);
            break;
    }

    this.showUpAction = new cc.Sequence(
        new cc.Show(),
        new cc.DelayTime(styles.showDelay),
        new cc.MoveTo(0.6, targetPosition).easing(cc.easeElasticOut(1.5))
    ).setFinalize(() => {
        this.setAlignment(targetPosition);
        delete this.showUpAction;
    });

    this.runAction(this.showUpAction);
};

Actor.prototype.exclamationAnimation = function (message) {
    let effect = "game.exclamations.alert";

    if (cleverapps.exclamation.getCongratulations().indexOf(message) !== -1) {
        const attack = PseudoRandom.GET().mathChoose(cleverapps.styles.Actor.actorActions);
        effect = attack.effect;
        cleverapps.Scenes.GetSceneComponent(Match3SceneComponent).actor.animate(attack.animation);
    } else if (message === "message.YouWin") {
        effect = "game.exclamations.win";
    } else if (message === "message.Shuffle") {
        effect = "game.exclamations.shuffle";
    }

    cleverapps.effects.fire(effect);
};

cleverapps.styles.Actor = cleverapps.overrideStyles(cleverapps.styles.Actor, {
    actorActions: [
        {
            animation: Actor.ANIMATIONS.ATTACK1,
            effect: "game.actor.welldone"
        },
        {
            animation: Actor.ANIMATIONS.ATTACK2,
            effect: "game.actor.welldone2"
        },
        {
            animation: Actor.ANIMATIONS.ATTACK3,
            effect: "game.actor.welldone3"
        }
    ]
});